export const SITE_CONFIG = {
  brand: "Bitevent 交易指南",
  inviteUrl: "https://bitevent.io/?ref=CAEC2977",
  officialUrl: "https://bitevent.io",
  verifiedAt: "2026-06-20",
  verifiedAtLabel: "2026 年 6 月 20 日",
  disclosure:
    "本站为独立制作的个人教程，并非 Bitevent 官方网站。通过本站推荐链接注册，链接提供者可能获得平台推荐权益，但不会增加你的交易成本。",
} as const;

export type MarketSnapshot = {
  symbol: string;
  name: string;
  accent: string;
  periods: string[];
  rateNote: string;
};

export const MARKET_SNAPSHOT: MarketSnapshot[] = [
  {
    symbol: "BTC",
    name: "Bitcoin",
    accent: "#f5a623",
    periods: ["30 秒", "1 分钟", "5 分钟", "10 分钟", "15 分钟", "1 小时"],
    rateNote: "快照回报率：90%",
  },
  {
    symbol: "ETH",
    name: "Ethereum",
    accent: "#8da6ff",
    periods: ["30 秒", "1 分钟", "5 分钟", "10 分钟", "15 分钟", "1 小时"],
    rateNote: "快照回报率：90%",
  },
  {
    symbol: "XAUT",
    name: "Tether Gold",
    accent: "#dbbc62",
    periods: ["30 秒", "5 分钟", "15 分钟", "1 小时"],
    rateNote: "快照回报率：70%–84%，随周期变化",
  },
];

export const RISKS = [
  {
    title: "短周期波动非常剧烈",
    text: "价格在数秒内就可能反向。更短的周期并不等于更容易判断。",
  },
  {
    title: "判断错误可能损失全部投入",
    text: "单笔投入不是保证金，而是该笔事件合约的最大风险金额。",
  },
  {
    title: "警惕连续交易",
    text: "亏损后立即加倍试图追回，可能让风险在很短时间内失控。",
  },
  {
    title: "充值网络必须完全一致",
    text: "充值前逐字核对币种、网络和地址；错误网络可能导致资产无法找回。",
  },
  {
    title: "只使用可承受损失的资金",
    text: "不要使用房租、贷款、应急金或其他生活必需资金参与交易。",
  },
] as const;

export const REBATE_LEVELS = [
  {
    level: "L0",
    rate: "0%",
    title: "注册用户",
    tone: "muted",
    description: "注册后默认等级，无交易返佣。",
    requirement: "无需申请",
  },
  {
    level: "L1",
    rate: "0.5%",
    title: "推广用户",
    tone: "green",
    description: "满足邀请条件后自动升级，按交易量享受 0.5% 返佣。",
    requirement: "3 名有效邀请用户",
  },
  {
    level: "L2",
    rate: "0.6%–1%",
    title: "合作代理",
    tone: "purple",
    description: "根据渠道能力与业务情况核定具体比例。",
    requirement: "手动申请或由官方 BD / 上级调整",
  },
  {
    level: "L3",
    rate: "1%–1.5%",
    title: "高级代理",
    tone: "gold",
    description: "平台最高代理等级，具体比例需审核确认。",
    requirement: "手动申请或由官方 BD / 上级调整",
  },
] as const;

export const REBATE_RULES = {
  validUserDeposit: 50,
  validUserVolume: 500,
  l1InviteCount: 3,
  minRate: 0,
  maxRate: 1.5,
  note:
    "有效用户需同时满足累计充值大于 50 USDT，且累计交易量大于 500 USDT。返佣比例、统计口径与发放状态以平台账户页面和官方审核结果为准。",
} as const;
